/* eslint-disable import/prefer-default-export */
const getGlobalState = (state, key) => (Array.isArray(state.earlyPayoutSettings[key]) ? state.earlyPayoutSettings[key].slice(0) : state.earlyPayoutSettings[key]);

export const selectorEarlyPayoutSettings = (state) => getGlobalState(state, 'earlyPayoutConfigurations');
